/**
 * Design decisions for the drop indicator's main line
 */
export var line = {
  borderRadius: 0,
  thickness: 2,
  backgroundColor: "var(--ds-border-brand, #0052CC)"
};